import { images } from "../lib/data";

export const Gallery = () => {
  const g = images.gallery;
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#f9f6f0] py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20 reveal">
          <div>
            <p className="overline text-[#5b7053]">A Taste in Pictures</p>
            <h2 className="font-serif-display mt-6 text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[#2c3528]">
              On the <span className="italic text-[#d98a6c]">table</span>{" "}
              tonight.
            </h2>
          </div>
          <p className="text-[#2c3528]/70 max-w-sm text-lg leading-relaxed">
            And save room for something sweet — our desserts are made fresh
            in-house and change with the season.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-6 grid-rows-2 gap-4 md:gap-6 h-[640px] md:h-[720px]">
          <figure className="col-span-6 md:col-span-3 row-span-2 relative overflow-hidden group reveal">
            <img
              src={g[0]}
              alt="Charcoal-grilled signature plate"
              className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
            />
            <figcaption className="absolute bottom-4 left-4 right-4 text-[#f9f6f0] font-serif-display text-2xl italic drop-shadow-md">
              From the grill, with smoke
            </figcaption>
          </figure>
          <figure className="hidden md:block md:col-span-2 row-span-1 relative overflow-hidden group reveal">
            <img
              src={g[1]}
              alt="Greek taverna details"
              className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
            />
          </figure>
          <figure className="hidden md:block md:col-span-1 row-span-1 relative overflow-hidden bg-[#2c3528] text-[#f9f6f0] reveal">
            <div className="absolute inset-0 p-5 flex flex-col justify-between">
              <span className="overline text-[#f1c98a]">No. 04</span>
              <p className="font-serif-display italic text-2xl leading-tight">
                Yamas <br />
                <span className="text-[#d98a6c]">&mdash;</span>
              </p>
            </div>
          </figure>
          <figure className="hidden md:block md:col-span-2 row-span-1 relative overflow-hidden group reveal">
            <img
              src={g[2]}
              alt="Mezze spread"
              className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
            />
          </figure>
          <figure className="hidden md:block md:col-span-1 row-span-1 relative overflow-hidden group reveal">
            <img
              src={g[3]}
              alt="Taverna setting"
              className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
            />
          </figure>
        </div>
      </div>
    </section>
  );
};
